import { Application } from "@hotwired/stimulus"
import { controllerIdentifierForPath } from './controller_identifier.mjs'

const application = Application.start()

application.debug = false
window.Stimulus = application

const controllers = import.meta.glob('../**/controller.js', { eager: true })
Object.entries(controllers).forEach(([path, controllerModule]) => {
    application.register(controllerIdentifierForPath(path), controllerModule.default)
})

export { application }
